import GreyOpacityText from "../UI/textFields/GreyOpacityText";
import drawerStyles from "../../styles/drawer.module.css";

const InfoBoxGreyBlackColumns = ({
  firstColumn,
  secondColumn,
}: {
  firstColumn: React.ReactNode;
  secondColumn: React.ReactNode | string;
}) => {
  return (
    <div className={`${drawerStyles.infoTextLines} gap-[var(--spacing-sm)]`}>
      <GreyOpacityText size="MEDIUM">{firstColumn}</GreyOpacityText>
      <p className="flex flex-col items-end leading-tight ">{secondColumn}</p>
    </div>
  );
};

export default InfoBoxGreyBlackColumns;
